module.exports = __webpack_public_path__ + "img/fangluomu.prt.96cafb88.jpg";